import { ContentVersioningDialog, NotificationItemType } from '@atlassian/learning-components';
import { ModalTransition } from '@atlaskit/modal-dialog';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { NotificationsMappedResponse, NotificationType, viewNotifications } from 'src/services/http/notifications';

export const VersioningModalWrapper: React.FC<{
  notifications: NotificationsMappedResponse;
  resourceTitle: string;
}> = ({ notifications, resourceTitle }) => {
  const [searchParams] = useSearchParams();
  const [notificationList, setNotifications] = useState<NotificationItemType[]>([]);
  const [isNotificationDialogOpen, setIsNotificationDialogOpen] = useState(false);

  useEffect(() => {
    if (!searchParams.has('notificationType')) {
      setNotifications(notifications.unseenNotifications);
    } else {
      const notificationType = searchParams.get('notificationType');

      if (notificationType === NotificationType.HISTORICAL) {
        setNotifications(notifications.historicalNotifications);
      } else {
        setNotifications(notifications.unseenNotifications);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIsNotificationDialogOpen(!!notificationList.length);
  }, [notificationList]);

  const handleViewNotifications = async (): Promise<void> => {
    const notificationIds = notifications.unseenNotifications.map((notification) => notification.id);

    if (notificationIds.length) {
      await viewNotifications(notificationIds);
    }
  };

  const closeModal = async (): Promise<void> => {
    await handleViewNotifications();
    setIsNotificationDialogOpen(false);
  };

  const onResourceLinkClick = async (resourceLink: string): Promise<void> => {
    await handleViewNotifications();
    window.open(resourceLink, '_blank');
  };

  if (!isNotificationDialogOpen) {
    return null;
  }

  return (
    <ModalTransition>
      <ContentVersioningDialog
        resourceTitle={resourceTitle}
        subtitle="We’ve updated some content you’ve completed. Your completion status isn’t affected, but you may want to take a look and refresh your knowledge."
        closeModal={closeModal}
        notifications={notificationList}
        onResourceLinkClick={onResourceLinkClick}
      />
    </ModalTransition>
  );
};
